import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";

import type { NodeViewProps } from "@tiptap/react";

export const ChatbotToolStatusView = ({ node }: NodeViewProps) => {
  const displayText = getLatestActiveStatus(node);
  if (!displayText) {
    return <NodeViewWrapper className="hidden" />;
  }

  return (
    <NodeViewWrapper>
      <div className="flex flex-row items-start p-[5px] gap-[3px] rounded-lg text-[15px] leading-[140%] tracking-[-0.02em] bg-gray-50 dark:bg-gray-800 text-gray-700 dark:text-gray-200 animate-pulse">
        <span aria-hidden className="font-mono">
          *
        </span>{" "}
        {displayText}
      </div>
    </NodeViewWrapper>
  );
};

function getLatestActiveStatus(node: NodeViewProps["node"]): string | undefined {
  for (let index = node.childCount - 1; index >= 0; index -= 1) {
    const text = node.child(index).textContent.trim();
    if (text.startsWith("* ")) {
      return text.slice(2).trim();
    }
  }

  return undefined;
}

export const chatbotToolStatusRenderer = ReactNodeViewRenderer(ChatbotToolStatusView);
